export default "__VITE_ASSET__BhFuh4Yj__"